import { PlayInstallReferrer } from "react-native-play-install-referrer";

const getRefererData = () =>
  new Promise((res, rej) => {
    PlayInstallReferrer.getInstallReferrerInfo((installReferrerInfo, error) => {
      const data = {};
      if (!error) {
        data.installReferrer = installReferrerInfo?.installReferrer;
        data.referrerClickTimestampSeconds =
          installReferrerInfo?.referrerClickTimestampSeconds;
        data.installBeginTimestampSeconds =
          installReferrerInfo?.installBeginTimestampSeconds;
        data.referrerClickTimestampServerSeconds =
          installReferrerInfo?.referrerClickTimestampServerSeconds;
        data.installBeginTimestampServerSeconds =
          installReferrerInfo?.installBeginTimestampServerSeconds;
        data.installVersion = installReferrerInfo?.installVersion;
        data.googlePlayInstant = installReferrerInfo?.googlePlayInstant;
        res(data);
      } else {
        rej(error);
      }
    });
  });

export { getRefererData };
